import { useSyncExternalStore } from "react";
import { getBoardAgent, subscribeBoardAgent } from "../board-agent-registry";
import type { BoardAgentContextValue } from "./board-agent-context";

function getSnapshot(): BoardAgentContextValue | null {
	return getBoardAgent();
}

function getServerSnapshot(): BoardAgentContextValue | null {
	return null;
}

export function useRegisteredBoardAgent() {
	return useSyncExternalStore(
		subscribeBoardAgent,
		getSnapshot,
		getServerSnapshot,
	);
}
